import {Record} from "ra-core";
import React from "react";
import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    Link,
    linkToRecord,
    NumberField,
    SelectField,
    TextField,
} from "react-admin";
import {CustomFileField} from "../components/CustomFIleField";
import {IdentifierField} from "../components/IdentifierField";
import {DatagridPropsWithOptions} from "../shared/types";
import {initField} from "../shared/utils";
import {Typography} from "@material-ui/core";
import {AssignedField} from "../ChartAccounts/DebtCollection/AssignedField";
import {InvoiceStatusField} from "./components/InvoiceStatusField";


export const PurchaseInvoiceDatagrid = ({
                                            options,
                                            ...rest
                                        }: DatagridPropsWithOptions) => {

    return (
        <Datagrid {...rest}>
            <IdentifierField show {...initField("id", options)} />
            <FunctionField render={function (record?: Record | undefined, source?: string) {
                return (
                    <AssignedField record={record}/>
                );
            }}
                           label="Assegna"
            />
            <FunctionField
                label="Azienda"
                source="company_object"
                render={(record: Record | undefined) => {
                    if (record && record.company) {
                        return (
                            <Link to={linkToRecord("/subjects", record.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.company_object}
                                    source="name"
                                    variant="inherit"

                                />
                            </Link>
                        );
                    }
                    return null;
                }}
            />
            <FunctionField
                label="Fornitore"
                source="client__business_name"
                sortBy="client__business_name"
                render={(record: Record | undefined) => {
                    if (record) {
                        return (
                            <Link to={linkToRecord("/subjects", record.client_id, "edit")}>
                                <TextField
                                    record={record.client}
                                    source="business_name"
                                    variant="inherit"
                                />
                            </Link>
                        );
                    }
                    return null;
                }}
            />
            <InvoiceStatusField/>
            <SelectField
                {...initField("invoice_type", options, "array")}
                choices={options.invoice_type.choices}
            />
            <SelectField
                {...initField("type", options, "array")}
                choices={options.type.choices}
            />
            <TextField {...initField("invoice_number", options)} />
            <DateField {...initField("invoice_date", options)} />
            <DateField {...initField("expiration_date", options)} />
            <NumberField {...initField("taxable", options)} />
            <NumberField {...initField("amount", options)} />
            <CustomFileField
                {...initField("file", options)}
                title="name"
                src="url"
            />
            <BooleanField {...initField("chart_account_handle", options)} label="Assegnato"/>
            <FunctionField
                label="Piano dei conti"
                source="chart_accounts"
                render={(record: Record | undefined) => {

                    if (record) {
                        return (
                            record.chart_accounts && (
                                record.chart_accounts.map((chart_account: any) => (
                                    <Typography>
                                        {chart_account}
                                    </Typography>
                                ))
                            )
                        );
                    }
                    return null;
                }}
            />

        </Datagrid>
    );
};
